import { Flex } from "antd";
import GenerateMessage from "../../Dashboard/CustomComponents/GenerateMessage";
import CreateTaskHeader from "../../ScrumBoard/Task/TaskCreateOrUpdate/CreateTaskHeader/CreateTaskHeader";
import { useContext } from "react";
import { AppContext } from "../../../context/ContextProvider";

export default function ExtraWarningsDrawer({ data }) {
    const { setOpenRightDrawer } = useContext(AppContext);
    const handleCancel = () => {
        setOpenRightDrawer({
            drawerType: null,
            drawerProps: {
                data: null,
                columnId: null,
            },
        });
    }
    return (<>
        <CreateTaskHeader buttonContent={data.title} onCancel={handleCancel}/>
        <Flex vertical style={{ marginTop: "90px", padding: "20px" }}>
            <ol style={{ paddingLeft: "10px" }}>
                {data.messages?.map((message, i) => (<li key={i} style={{ marginBottom: "10px" }}><GenerateMessage content={message} i={i} /></li>))}
            </ol>
        </Flex>
    </>)
}